import { fadeIn } from "cssinjs-animations"
import { getCurrentHost } from "../../utils/getHost"

const styles = theme => ({
  "@keyframes fadeIn": fadeIn,
  crewSection: {
    display: "flex",
    padding: 32,
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
    },
  },
  crewSectionWrapper: {
    display: "flex",
    flexWrap: "wrap",
  },
  crewCardWrapper: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  contentWrapper: {
    flexGrow: 1,
  },
  searchMenuPaper: {
    width: 500,
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    height: 350,
  },
  searchMenuItemPaper: {
    marginRight: [0, "!important"],
    marginBottom: theme.spacing(2),
    "&:last-of-type": {
      marginBottom: 0,
    },
  },
  searchMenuAutoComplete: {
    width: "100%",
  },
  filterMenuPaper: {
    width: 240,
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
  },
  filterMenuItem: {
    display: "flex",
    justifyContent: "space-between",
  },
  actionCardWrapper: {
    flexGrow: 0,
    flexShrink: 0,
  },
  actionCard: {
    maxWidth: 300,
    textAlign: "left",
  },
  autoCompleteUnderline: {
    "&:before": {
      border: ["none", "!important"],
    },
  },
  chipsWrapper: {
    padding: 32,
    paddingBottom: 12,
    textAlign: "left",
  },
  chip: {
    backgroundColor: theme.palette.primary.main,
    margin: theme.spacing(1 / 4),
    color: "#fff",
    marginTop: 12,
  },
  chipDeleteIcon: {
    color: "#fff",
  },
  resultsWrapper: {
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(3),
    animationName: "fadeIn",
    animationDuration: theme.transitions.duration.shortest,
    animationDelay: 500,
    animationFillMode: "forwards",
  },
  resultsNumber: {
    fontFamily: '"Oswald"',
    fontWeight: 400,
    fontSize: 34,
    marginRight: theme.spacing(1),
    lineHeight: "0.9em",
  },
  resultsText: {
    width: 70,
    textAlign: "left",
    lineHeight: "1em",
  },
  arrowIcon: {
    width: "0.8em",
    transition: theme.transitions.create("transform", {
      easing: theme.transitions.easing.sharp,
    }),
  },
  arrowDown: {
    transform: "rotate(180deg)",
  },
  arrowOut: {
    transform: "scale(0)",
  },
  legendButton: {
    position: "fixed",
    bottom: "83px",
    right: "20px",
    zIndex: 5,
  },
  pageBackground: {
    backgroundColor: getCurrentHost() === "crewmama" ? "#ffffff" : "#f8f8f8",
  },
})

export default styles
